"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConnectionSettings = void 0;
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const css_1 = require("@emotion/css");
const ui_1 = require("@grafana/ui");
const ConfigSection_1 = require("../ConfigSection");
const ConnectionSettings = ({ config, onChange, description, urlPlaceholder, urlTooltip, urlLabel, className, }) => {
    const isValidUrl = config.url !== undefined &&
        /^(ftp|http|https):\/\/(\w+:{0,1}\w*@)?(\S+)(:[0-9]+)?(\/|\/([\w#!:.?+=&%@!\-\/]))?$/.test(config.url);
    const styles = {
        container: (0, css_1.css)({
            maxWidth: 578,
        }),
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(ConfigSection_1.ConfigSection, { title: "Connection", description: description, className: (0, css_1.cx)(styles.container, className) },
            react_1.default.createElement(ui_1.InlineField, { htmlFor: "connection-url", label: urlLabel || 'URL', labelWidth: 24, tooltip: urlTooltip || (react_1.default.createElement(react_1.default.Fragment, null,
                    "Specify a complete HTTP URL",
                    react_1.default.createElement("br", null),
                    "(for example https://example.com:8080)")), grow: true, disabled: config.readOnly, required: true, invalid: !isValidUrl && !config.readOnly, error: isValidUrl ? '' : 'Please enter a valid URL', interactive: true },
                react_1.default.createElement(ui_1.Input, { id: "connection-url", "aria-label": "Data source connection URL", onChange: (event) => onChange(Object.assign(Object.assign({}, config), { url: event.currentTarget.value })), value: config.url || '', placeholder: urlPlaceholder || 'URL' })))));
};
exports.ConnectionSettings = ConnectionSettings;
//# sourceMappingURL=ConnectionSettings.js.map